import { request } from "../utils";

const configureRequest = (): void => {
  request.defaults.headers.common = {
    ...request.defaults.headers.common,
    "X-Key-Inflection": "camel",
  };

  request.defaults.baseURL = process.env.REACT_APP_API_URL;
};

export default configureRequest;
